// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert-wrapper[data-v-3b974f24]  svg{min-width:24px;min-height:24px}.alert-wrapper .text-list[data-v-3b974f24]{list-style:unset;margin-left:24px}.alert-wrapper .text-list li[data-v-3b974f24]::marker{color:#273142}", ""]);
// Exports
module.exports = exports;
